import { render, staticRenderFns } from "./TermsCooperation.vue?vue&type=template&id=48ed7508&"
import script from "./TermsCooperation.vue?vue&type=script&lang=js&"
export * from "./TermsCooperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports